import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import { Box, BoxSection } from 'components/_new/Box';

const NotificationPostSkeleton = () => {
	return (
		<Box variant="white-bordered">
			<BoxSection className="notification-post">
				<div className="flex mb-4">
					<Skeleton shape="circle" size="48px" />
					<div className="ml-3 flex flex-column justify-content-between flex-1">
						<Skeleton width="60%" height="16px" className="mb-2" />
						<Skeleton width="40%" height="14px" />
					</div>
				</div>

				<Skeleton width="80%" height="20px" className="mb-3" />

				<div className="mb-2">
					<Skeleton width="100%" height="16px" className="mb-2" />
					<Skeleton width="95%" height="16px" className="mb-2" />
					<Skeleton width="90%" height="16px" className="mb-2" />
					<Skeleton width="70%" height="16px" />
				</div>
			</BoxSection>
		</Box>
	);
};

export default NotificationPostSkeleton;
